// extracted by mini-css-extract-plugin
export default {"component":"navigation_component__hlKsY","grid":"navigation_grid__e0+no","card":"navigation_card__YGcz2","icon":"navigation_icon__ZzvHa","name":"navigation_name__D4LMB"};